import request from "@/http/request"
import {
  getReviewTeacherList,
  setReviewTeacher,
  delReviewTeacher,
  importReviewTeacher,
  editPsd,
  getCourseReview,
  isAutoAllocation,
  importReResult,
  autoLocation,
  delLocation,
  delCourseReveiw,
  getPlanSession,
  getPlanCourseTeacher,
  getStudentTeacher,
  selectTeacherReviewList,
  importTeacherReviewList,
  bulkAllocation,
  exportAllocation,
  getTeacherPlanList,
  getTeacherReviewCount,
  getTeacherReviewList,
  teacherReviewToOts,
  getReviewUrl,
  getTeacherReviewAllList,
  getTeacherReviewTimeList,
  updateTeacherReviewTime,
  judgeTimeRange,
  judgeHaveTeacher
} from '@/http/api'

export const getTeacherList = (data) => {
  return request({
    url: getReviewTeacherList,
    data
  })
}
export const ReviewTeacherSet = (data) => {
  return request({
    url: setReviewTeacher,
    data
  })
}
export const delReTeacher = (data) => {
  return request({
    url: delReviewTeacher,
    data
  })
}
export const importReTeacher = (data) => {
  return request({
    url: importReviewTeacher,
    isUpload: true,
    data,
  })
}
export const editReviewPsd = (data) => {
  return request({
    url: editPsd,
    data
  })
}
export const getAutoReview = (data) => {
  return request({
    url: getCourseReview,
    data
  })
}
export const isAutoDis = (data) => {
  return request({
    url: isAutoAllocation,
    data
  })
}
export const importResult = (data) => {
  return request({
    url: importReResult,
    data
  })
}
export const autoLocationSet = (data) => {
  return request({
    url: autoLocation,
    data
  })
}
export const delLocationSet = (data) => {
  return request({
    url: delLocation,
    data
  })
}
export const delReAuto = (data) => {
  return request({
    url: delCourseReveiw,
    data
  })
}
export const getSession = (data) => {
  return request({
    url: getPlanSession,
    data
  })
}
export const getReTeacher = (data) => {
  return request({
    url: getPlanCourseTeacher,
    data
  })
}
export const geTeacherList = (data) => {
  return request({
    url: getStudentTeacher,
    data
  })
}
export const selectTeacherReview = (data) => {
  return request({
    url: selectTeacherReviewList,
    data
  })
}
export const importTeacherReviewListSet = (data) => {
  return request({
    url: importTeacherReviewList,
    data
  })
}
export const bulkLocation = (data) => {
  return request({
    url: bulkAllocation,
    data
  })
}
export const exportLocation = (data) => {
  return request({
    url: exportAllocation,
    data
  })
}
export const getPlanList = (data) => {
  return request({
    url: getTeacherPlanList,
    data
  })
}
export const getReviewCount = (data) => {
  return request({
    url: getTeacherReviewCount,
    data
  })
}
export const getReviewList = (data) => {
  return request({
    url: getTeacherReviewList,
    data
  })
}
export const teacherToOts = (data) => {
  return request({
    url: teacherReviewToOts,
    data
  })
}
export const getUrl = (data) => {
  return request({
    url: getReviewUrl,
    data
  })
}
export const TeacherReviewAllList = (data) => {
  return request({
    url: getTeacherReviewAllList,
    data
  })
}
export const getTeacherReviewTimeListSet = (data) => {
  return request({
    url: getTeacherReviewTimeList,
    data
  })
}
export const updateTeacherReviewTimeSet = (data) => {
  return request({
    url: updateTeacherReviewTime,
    data
  })
}
export const judgeTimeRangeSet = (data) => {
  return request({
    url: judgeTimeRange,
    data
  })
}
export const judgeHaveTeacherquery = (data) => {
  return request({
    url: judgeHaveTeacher,
    data
  })
}
// getReviewUrl